export const cdnResourceListGql = `query {
  cdn_resource(_order_by: { create_time: _desc }, _limit: $limit, _offset: $offset, _where: {name: {_ilike: $name}}) {
    id
    name
    cdn_url
    create_time
    create_by.name
    remark
    _aggregate {_count}
  }
}`;

export const addCdnResourceGql = `mutation insert {cdn_resource(_values: {name: $name, cdn_url: $cdn_url, remark: $remark})}`;

export const deleteCdnResourceGql = `mutation delete {cdn_resource(id: $id)}`;
